<template>
  <div>
    <button
      class="ui-button"
      type="button"
      :disabled="disabled"
      @click="decrement"
    >
      -
    </button>
    <input
      ref="numberInput"
      :value="intValue"
      type="text"
      :disabled="disabled"
      @input="set"
    />
    <button
      class="ui-button"
      type="button"
      :disabled="disabled"
      @click="increment"
    >
      +
    </button>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 0 },
    step: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false }
  },
  data: function() {
    return {
      intValue: 0
    };
  },
  computed: {
    canIncrement() {
      if (this.disabled) return false;
      return this.max === undefined || this.intValue + this.step <= this.max;
    },
    canDecrement() {
      if (this.disabled) return false;
      return this.intValue - this.step >= this.min;
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        this.intValue = newVal;
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.keyUp);
  },
  created() {
    this.intValue = this.value;
    if (this.step < 1) this.step = 1;
    if (this.max < this.min) this.max = undefined;
  },
  methods: {
    keyUp(event) {
      if (this.isFocused()) {
        if (event.keyCode === 33 || event.keyCode === 38) {
          // page up || up arrow
          this.increment();
          event.preventDefault();
        }

        if (event.keyCode === 34 || event.keyCode === 40) {
          // page down || down arrow
          this.decrement();
          event.preventDefault();
        }

        if (event.keyCode === 36) {
          // home button
          this.setToMin();
          event.preventDefault();
        }

        // if max, set to max
        if (this.max !== undefined && event.keyCode === 35) {
          // end button
          this.setToMax();
          event.preventDefault();
        }
      }
    },
    isFocused() {
      return document.activeElement === this.$refs.numberInput;
    },
    setToMin() {
      if (this.disabled) return;
      this.intValue = this.min;
      this.$emit('input', this.intValue);
    },
    setToMax() {
      if (this.disabled) return;
      this.intValue = this.max;
      this.$emit('input', this.intValue);
    },
    increment() {
      if (this.canIncrement) {
        this.intValue = this.intValue + this.step;
        this.$emit('ipm-increment', this.intValue);
        this.$emit('input', this.intValue);
      }
    },
    decrement() {
      if (this.canDecrement) {
        this.intValue = this.intValue - this.step;
        this.$emit('ipm-decrement', this.intValue);
        this.$emit('input', this.intValue);
      }
    },
    set(event) {
      if (this.disabled) return;
      var value = parseInt(event.target.value, 10) || 0;
      event.target.value = value;
      if (value > this.max) {
        event.target.value = this.intValue;
      } else {
        this.intValue = value;
      }
      this.$emit('input', this.intValue);
    }
  }
};
</script>
